import { buildClassName } from './buildClassName';
import type { OptionSelectHandler } from '../hooks/useCarConfiguration';
import type { WeatherOption } from '../types';

export interface WeatherSelectorProps {
  options: readonly WeatherOption[];
  selectedOptionId: string;
  onOptionSelect: OptionSelectHandler;
}

/** 날씨는 색만으로 구분할 수 없으므로 아이콘과 이름을 함께 표시하는 카드로 고릅니다. */
export function WeatherSelector({
  options,
  selectedOptionId,
  onOptionSelect,
}: WeatherSelectorProps) {
  return (
    <ul className="weather-option-list" aria-label="날씨 선택">
      {options.map((option) => {
        const selected = option.id === selectedOptionId;
        return (
          <li key={option.id}>
            <button
              type="button"
              className={buildClassName('weather-option', 'weather-option--selected', selected)}
              aria-pressed={selected}
              aria-label={`${option.name}: ${option.description}`}
              onClick={() => onOptionSelect(option.id)}
            >
              <span className="weather-option__icon" aria-hidden="true">
                {option.icon}
              </span>
              <span className="weather-option__name">{option.name}</span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
